import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-2">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center text-sm">
        <p className="text-xs sm:text-sm">Dominic & Florian's Berlin Home - Est. 2020</p>
        <div className="flex space-x-2">
          <img src="/images/Ampelmann_Gruen.svg" alt="Ampelmann Go" className="w-5 h-5 sm:w-6 sm:h-6" />
          <img src="/images/Ampelmann_Rot.svg" alt="Ampelmann Stop" className="w-5 h-5 sm:w-6 sm:h-6" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;